// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme-colors-actions{position:absolute;top:5px;right:10px}", ""]);
// Exports
module.exports = exports;
